import _ from 'lodash';
import { NodeType } from 'utils/types';

/**
 * merge current not with its descendendants.
 * NB assetDescendendents has ALL descendents for the node not just its children
 * @param {*} node
 * @returns
 */
export const mapNodeAndAssetDescendants = (node) => {
  if (node == null) {
    return [];
  }
  return [node, ...(node.assetDescendants ?? [])];
};

export const assetsFromNodes = (nodes) => {
  const allNodes = _.flatMap(nodes, mapNodeAndAssetDescendants);
  const allAssets = _.filter(allNodes, node => NodeType.Asset === node.type);
  return allAssets;
};
